import React, { useCallback } from 'react';
import {
  modalTypes,
  useModalState,
  useModalDispatch,
  modalActionTypes,
} from '../../../../shared/lib/toggleModalVisble';
import { Form, Modal } from 'antd';
import { isStorageAvailable } from '../../../../../../helpers/storage';
import ModalFooter from './ModalFooter/ModalFooter';
import ShutdownForm from './ShutdownForm/ShutdownForm';
import DraftInfoWithActions from './DraftInfoWithActions/DraftInfoWithActions';
import { useCreateShutdown } from '../api';
import { transformFormValues } from '../../common/lib/formValuesHelpers';
import { changeModalWithInfoBodyStyle } from '../../common/config';

const { confirm } = Modal;

const OpenCreateShutdownModalNew = ({ render, ...props }) => {
  const dispatch = useModalDispatch();

  const open = useCallback(
    (data) => {
      dispatch({
        type: modalActionTypes.setModalData,
        payload: {
          type: modalTypes.createShutdown,
          ...(data?.initialValues ? { initialValues: data.initialValues } : {}),
        },
      });
    },
    [dispatch]
  );

  return render({ open, ...props });
};

const localStorageAvailable = isStorageAvailable();

const ModalContainer = ({
  form,
  renderResTemplateAction,
  renderResTemplateOptionActions,
}) => {
  const { type } = useModalState();
  const dispatch = useModalDispatch();

  const close = () => {
    form.resetFields();
    dispatch({ type: modalActionTypes.resetModalData });
  };

  const { create, loading } = useCreateShutdown();

  const handleSubmit = () => {
    form.validateFieldsAndScroll(async (err, formValues) => {
      if (!err) {
        const { autoResponder, ...restValues } = formValues;
        const values = transformFormValues(restValues);
        await create(values);
        close();
      }
    });
  };

  const handleClose = () => {
    if (form?.isFieldsTouched()) {
      confirm({
        title: 'Вы уверены, что хотите закрыть окно? ',
        content: 'Введенные Вами данные будут потеряны.',
        zIndex: 20000,
        onOk: () => {
          close();
        },
        onCancel: () => {},
      });
      return;
    }

    close();
  };

  const visible = type === modalTypes.createShutdown;

  return (
    <Modal
      visible={visible}
      onCancel={handleClose}
      onOk={handleSubmit}
      title="Создание отключения"
      style={{ top: '100px' }}
      destroyOnClose
      confirmLoading={Boolean(loading)}
      bodyStyle={
        localStorageAvailable ? changeModalWithInfoBodyStyle : undefined
      }
      width="700px"
      footer={
        localStorageAvailable ? (
          <ModalFooter
            loading={Boolean(loading)}
            form={form}
            onCancel={handleClose}
            onSubmit={handleSubmit}
          />
        ) : undefined
      }
    >
      {localStorageAvailable ? <DraftInfoWithActions form={form} /> : null}
      <ShutdownForm
        form={form}
        renderResTemplateAction={renderResTemplateAction}
      />
    </Modal>
  );
};

const CreateShutdownModalNew = Form.create({ name: 'create_shutdown_new' })(
  ModalContainer
);

export { CreateShutdownModalNew, OpenCreateShutdownModalNew };
